import { UtilUrl } from "../Core/Utils/UtilUrl.js";
import { UtilForm } from "../Core/Utils/UtilForm.js";
import {UtilDomBuilder} from "../Core/Utils/UtilDomBuilder.js";

class QuickBuy {
    static #reasonSkuNotFound = 'SKU not found';
    #uploadButton = null;
    #fileInput;
    #endpointUpload = '';
    #endpointSkuSearch = '';
    #endpointSkuCheck = '';
    #rowTemplate = null;
    #rowRequestTemplate = null;
    #requestContainer = null;
    #searchMinLength = 3;
    //#uploadAddedAlert = null;
    #uploadLoggedAlert = null;
    #uploadErrorAlert = null;
    #loggedModalTblBody = null;
    
    constructor(endpointUpload, endpointSkuSearch, endpointSkuCheck, searchMinLength) {
        let uploadForm = document.getElementById('quickbuy-upload');
        this.#uploadButton = uploadForm.querySelector('button');
        this.#fileInput = uploadForm.querySelector('input[type="file"]');
        this.#endpointUpload = endpointUpload;
        this.#endpointSkuSearch = endpointSkuSearch;
        this.#rowTemplate = jQuery(jQuery('#row-template')[0].outerHTML).removeAttr('id').removeClass('hidden');
        
        this.#rowRequestTemplate =  jQuery(jQuery('#row-request-template')[0].outerHTML).removeAttr('id').removeClass('hidden');
        this.#requestContainer =  document.getElementById('quickbuy-request-container');
        this.#endpointSkuCheck = endpointSkuCheck;
        this.#searchMinLength = searchMinLength;
        //this.#uploadAddedAlert = document.getElementById('quickbuy-upload-added');
        this.#uploadLoggedAlert = document.getElementById('quickbuy-upload-logged');
        this.#uploadErrorAlert = document.getElementById('quickbuy-upload-error');
        this.#loggedModalTblBody = document.getElementById('modal-logged-items').querySelector('.modal-body tbody');
        
    }

    init() {
        this.#initUpload();
        this.#initRequestSkus();
        this.#initAutoComplete();
        this.#initAddToCartButton();
    }

    #initAddToCartButton() {
        const submitBtn = jQuery('#quickbuy-form button[name="quickbuy-submitted"]');
        submitBtn.on('click', ()  => {
            //remove required attribute
            const requiredSelector = 'input[required],textarea[required],select[required]';
            let requiredFields = jQuery('#quickbuy-request-fields').find(requiredSelector);
            requiredFields.each((idx, element) => {
                jQuery(element).prop('required', false);
            });
        });
    }

    #initAutoComplete() {
        //autocomplete result otherwise is bigger then input:
        jQuery.ui.autocomplete.prototype._resizeMenu = function () {
            var ul = this.menu.element;
            ul.outerWidth(this.element.outerWidth());
        };
        jQuery("#quickbuy-search").autocomplete({
            source: this.#endpointSkuSearch,
            minLength: this.#searchMinLength,
            select: (event, ui) => {
                this.#onSelect(ui);
            }
        });
    }

    #initRequestAutoComplete(fieldSku) {
        fieldSku.autocomplete({
            source: this.#endpointSkuSearch,
            minLength: this.#searchMinLength,
            select: (event, ui) => {
                fieldSku.val(ui.item.sku);
            }
        });
    }

    #initFileInput() {        
        this.#fileInput.addEventListener('change', () => {
            this.#uploadButton.disabled = this.#fileInput.files.length === 0;
        });
    }
    #initUpload() {
        this.#initFileInput();
        this.#uploadButton.addEventListener('click', () => {
            //Disable button
            this.#uploadButton.disabled = true;
            //this.#uploadAddedAlert.classList.add('hidden');
            this.#uploadLoggedAlert.classList.add('hidden');
            this.#uploadErrorAlert.classList.add('hidden');
            this.#loggedModalTblBody.innerHTML = '';

            //Create form data
            const formData = new FormData();
            formData.append('spreadsheet', document.querySelector('input[type="file"]').files[0]);
            //Send request
            fetch(this.#endpointUpload, {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    this.#onUpload(data);
                })
                .catch(error => {
                    //Show error message
                    this.#showErrorAlert(error.message);
                }).finally(() => {
                    this.#clearFileInput();
                });
        });
    }

    #showErrorAlert(message) {
        this.#uploadErrorAlert.classList.remove('hidden');
        this.#uploadErrorAlert.querySelector('.message').innerHTML = message;
    }

    #clearFileInput() {
        let clonedInput = UtilForm.clearFileInput(this.#fileInput);
        //re-init file input in case it was cloned for clearing (older browsers)
        if (clonedInput) {
            this.#fileInput = clonedInput;
            this.#initFileInput();
        }
    }
    #onUpload(data) {
        //Check if upload was successful
        if (data.success) {
            this.#addRealizedItems(data.realizedItems);
            this.#reportUpload(data);
            this.#skusNotFoundToRequest(data.loggedItems);
        } else {
            //Show error message
            this.#showErrorAlert(data.message);
        }
    }

    #reportUpload(data) {
        /* No more realized report
        if (data.realizedItems.length > 0) {
            this.#uploadAddedAlert.classList.remove('hidden');
            this.#uploadAddedAlert.querySelector('.message').innerHTML = data.realizedSummary; 
        }*/
        if (data.loggedItems.length > 0) {
            this.#uploadLoggedAlert.classList.remove('hidden');
            this.#uploadLoggedAlert.querySelector('.message').innerHTML = data.loggedSummary;
            this.#fillLoggedModal(data.loggedItems);
        }
    }

    #fillLoggedModal(loggedItems) {
        loggedItems.forEach(item => {
            let tr = UtilDomBuilder.appendNewChild(this.#loggedModalTblBody, 'tr');
            UtilDomBuilder.appendNewChild(tr, 'td', item.sku ?item.sku: '-');
            UtilDomBuilder.appendNewChild(tr, 'td', item.invalidityReason);
        });
    }

    #addRealizedItems(realizedItems) {
        realizedItems.forEach(ui => {
            this.#addProductRow(ui);
        });
        this.#updateVisibilities();
    }

    #initRequestSkus() {
        let strSkus = UtilUrl.getUrlParam('skus');
        let skus = new Array();
        if (strSkus) {
            skus = strSkus.split(',').map(x => x.trim());
        }
        for (var idx = 0; idx < skus.length; ++idx) {
            let sku = skus[idx];
            if (sku != '') {
                jQuery.getJSON(this.#endpointSkuSearch, { 'term': sku }, function (data) {
                    var ui = { 'item': data[0] };
                    this.#onSelect(ui);
                });
            }
        }
    }

    #onSelect(ui, silent) {
        jQuery.get(this.#endpointSkuCheck, { productId: ui.item.id },
            result => {
                if (result.isSaleable) {
                    this.#addProductRow(ui);
                    this.#updateVisibilities();
                    jQuery('#quickbuy-search').val('');
                } else if (!silent) {
                    var alertBox = jQuery('#product-not-saleable');
                    alertBox.fadeIn(500, function () {
                        window.setTimeout(function () {
                            alertBox.fadeOut(500);
                        }, 1500);
                    });
                }
            }, 'json');
    }

    #updateVisibilities() {
        const hasProductRows = jQuery('#quickbuy-table tr.quickbuy-product').length > 1;
        const submitBtn = jQuery('#quickbuy-form button[name="quickbuy-submitted"]');
        if (hasProductRows) {
            jQuery('#quickbuy-table-title').removeClass('hidden');
            jQuery('#quickbuy-table-description').removeClass('hidden');
            jQuery('#quickbuy-table').removeClass('hidden');
            submitBtn.removeClass('hidden');
        }
        else {
            jQuery('#quickbuy-table-title').addClass('hidden');
            jQuery('#quickbuy-table-description').addClass('hidden');
            jQuery('#quickbuy-table').addClass('hidden');
            submitBtn.addClass('hidden');
        }
        this.#ubpdateBtnSubmitBoth();    
    }

    #updateRequestVisibilities() {
        
        let tableBody = jQuery(this.#requestContainer).find('table tbody');
        if (tableBody.find('tr').length > 1) {
            jQuery(this.#requestContainer).removeClass('hidden');
        } else {
            jQuery(this.#requestContainer).addClass('hidden');
        }
        this.#ubpdateBtnSubmitBoth();
    }

    #ubpdateBtnSubmitBoth() {
        const hasProductRows = jQuery('#quickbuy-table tr.quickbuy-product').length > 1;
        const submitBothBtn = jQuery('#quickbuy-form button[name="quickbuy-both-submitted"]');
        if (hasProductRows) {
            submitBothBtn.removeClass('hidden');
        }
        else {
            submitBothBtn.addClass('hidden');
        }
    }

    
    #initRow(row) {
        const me = this;
        jQuery(row).find('.delete-row').on('click', function (e) {
            e.preventDefault();
            jQuery(this).closest('tr').remove();
            me.#updateVisibilities();
        });
    }

    #initRequestRow(requestRow) {
        const me = this;
        jQuery(requestRow).find('.delete-row').on('click', function (e) {
            e.preventDefault();
            jQuery(this).closest('tr').remove();
            me.#updateRequestVisibilities();
        });
    }
    #addProductRow(ui) {
        let newRow = jQuery(this.#rowTemplate).clone();
        jQuery(newRow).find('.product_id').val(ui.item.id);
        jQuery(newRow).find('.sku').text(ui.item.sku);
        jQuery(newRow).find('.name').text(ui.item.name);
        jQuery(newRow).find('.amount').text(ui.item.amount);
        jQuery(newRow).find('.manufacturer').text(ui.item.manufacturer);
        var toggleClass = jQuery('#quickbuy-table').find('tr').length % 2 === 0 ? 'odd' : 'even';
        if (ui.item.quantity)  {
            jQuery(newRow).find('.qty').val(ui.item.quantity);
        }
        jQuery(newRow).addClass(toggleClass);
        jQuery('#quickbuy-table tbody').append(newRow);
        this.#initRow(newRow);
    }
    /**
     * 
     * @param Array loggedItems 
     */
    #skusNotFoundToRequest(loggedItems) {
        let skuNotFoundItems = loggedItems.filter(item => {return item.invalidityReason == QuickBuy.#reasonSkuNotFound;});
        if (skuNotFoundItems.length == 0) {
            return;    
        }
        let tableBody = jQuery(this.#requestContainer).find('table tbody');
        skuNotFoundItems.forEach(item => {
            let newRow = jQuery(this.#rowRequestTemplate).clone();
            let fieldSku = jQuery(newRow).find('.sku');
            fieldSku.val(item.sku);
            fieldSku.prop('required', true);
            this.#initRequestAutoComplete(fieldSku);
            this.#initRequestRow(newRow);

            let fieldQty = jQuery(newRow).find('.qty');
            fieldQty.prop('required', true);
            fieldQty.val(item.quantity);

            var toggleClass = tableBody.find('tr').length % 2 === 0 ? 'odd' : 'even';
            jQuery(newRow).addClass(toggleClass);
            tableBody.append(newRow);
        });
        this.#updateRequestVisibilities();
    }

}

export { QuickBuy };